/**
 * @module lib/webauthn
 * @description Browser WebAuthn adapters used by passwordless authentication
 * and passkey enrollment flows.
 */

import {
  startAuthentication,
  startRegistration,
} from "@simplewebauthn/browser";

/** Return whether this browser exposes the WebAuthn API. */
export function browserSupportsWebAuthn(): boolean {
  return typeof window !== "undefined" && Boolean(window.PublicKeyCredential);
}

/** Start a passkey authentication ceremony with server-provided options. */
export async function authenticateWithPasskey(options: unknown): Promise<unknown> {
  return startAuthentication({ optionsJSON: options as Parameters<typeof startAuthentication>[0]["optionsJSON"] });
}

/** Start a passkey registration ceremony with server-provided options. */
export async function registerPasskeyDevice(options: unknown): Promise<unknown> {
  return startRegistration({ optionsJSON: options as Parameters<typeof startRegistration>[0]["optionsJSON"] });
}
